import React from 'react';
import { footerLinks } from '../data/content';
export function Footer() {
  return <footer className="w-full border-t border-white/10 bg-ink-900 px-4 py-12 sm:px-5 sm:py-16" data-id="element-82" data-mp="3geze367ujv27">
      <div className="mx-auto max-w-4xl text-center" data-id="element-83" data-mp="32o4ao9g4a660">
        <p className="text-lg font-extrabold uppercase tracking-[0.2em] text-brand-500" data-id="element-84" data-mp="32pfci3q053uh">
          VALUX™
        </p>

        <p className="mx-auto mt-4 max-w-2xl text-sm leading-relaxed text-gray-300" data-id="element-85" data-mp="36nd1b5fv1nxc">
          El sistema de operaciones B2B N°1 para mayoristas, fabricantes y
          distribuidores en Argentina. Porque tener stock no alcanza si no tenés
          el sistema para moverlo.
        </p>

        <ul className="mt-8 flex flex-wrap items-center justify-center gap-x-5 gap-y-3 text-sm" data-id="element-86" data-mp="3le2f8fkphh4w">
          {footerLinks.map(link => <li key={link.label} data-id="element-87" data-mp="29zgnu9fpz8qc">
              <a href={link.href} target={link.href.startsWith('http') ? '_blank' : undefined} rel={link.href.startsWith('http') ? 'noopener noreferrer' : undefined} className="inline-flex items-center gap-2 text-gray-300 transition-colors hover:text-brand-500 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-400" data-id="element-88" data-mp="29ydwk0ehj49w">
                <span aria-hidden="true" data-id="element-89" data-mp="3q8n125k1gf82">{link.icon}</span>
                {link.label}
              </a>
            </li>)}
        </ul>

        <p className="mx-auto mt-10 max-w-2xl border-t border-white/10 pt-8 text-xs leading-relaxed text-gray-500" data-id="element-90" data-mp="81pgvn5hf5bh">
          © VALUX™ 2026 — Todos los derechos reservados. Prohibida la
          reproducción y redistribución sin autorización expresa.
        </p>

        <p className="mx-auto mt-6 max-w-xl text-sm italic text-brand-400" data-id="element-91" data-mp="cu0hytbykx5m">
          "Tu WhatsApp tiene que ser una terminal de cobro, no un centro de
          atención gratuito."
        </p>
      </div>
    </footer>;
}